import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=dd9f80a4&scoped=true&"
import script from "./projectDetail.vue?vue&type=script&lang=js&"
export * from "./projectDetail.vue?vue&type=script&lang=js&"
import style0 from "./projectDetail.vue?vue&type=style&index=0&id=dd9f80a4&prod&scoped=true&lang=scss&"
import style1 from "./projectDetail.vue?vue&type=style&index=1&id=dd9f80a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9f80a4",
  null
  
)

export default component.exports